<section class="login-block" *ngIf="isLoaded">
  <!-- Container-fluid starts -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <!-- Authentication card start -->
        <div class="text-center mb-5">
          <img src="assets/images/urbansofa_logo_white.png" width="150"/>
        </div>
        <div class="card">
          <div class="card-body">
            <h3 class="card-title text-center mb-3">{{'admin.terms.accept.title'|translate}}</h3>
            <div class="text-end"><a
              href="{{baseUrl+'/download?path='+userTerm.term.file.path+'&filename='+userTerm.term.file.filename}}"
              class="card-link"
              download="download">{{'admin.terms.download_btn'|translate}}</a>
            </div>
            <div class="border border-secondary text-justify rounded p-3 m-3" [innerHTML]="userTerm.term.terms"></div>
            <div class="container">
              <app-classic-box #classicForm [classicBox]="classicBox" [data]="userTerm"
                               (changeForm)="enableButton($event)"></app-classic-box>
              <button [disabled]="!enableSave" (click)="submitTerm()" class="btn btn-primary ripple light"
                      type="button">{{'global.send'|translate}}</button>
            </div>
          </div>
        </div>
        <!-- end of form -->
      </div>
      <!-- end of col-sm-12 -->
    </div>
    <!-- end of row -->
  </div>
  <!-- end of container-fluid -->
</section>
